import * as types from './actionTypes';
import { api } from './api';

export function updateClaim(claim) {
	return { type: types.CLAIM__UPDATE_CLAIM, claim };
}

export function resetClaim() {
	return { type: types.CLAIM__RESET_CLAIM };
}

export function submitClaimV2(claim, emailDetails, files) {
	const command = JSON.stringify(claim);
	var body = new FormData();
	body.append('command', command);
	body.append('emailDetails', emailDetails);

	files.forEach((file) => {
		body.append('files', file);
	});

	return api({
		types: [types.CLAIM__REPORT_REQUEST, types.CLAIM__REPORT_SUCCESS, types.CLAIM__REPORT_FAILURE],
		uri: '/api/claim/v2',
		config: {
			method: 'post',
			headers: {
				Accept: 'application/json',
				ContentType: 'multipart/form-data',
			},
			body,
		},
		payload: { claim },
	});
}

export function submitClaim(claim) {
	return api({
		types: [types.CLAIM__REPORT_REQUEST, types.CLAIM__REPORT_SUCCESS, types.CLAIM__REPORT_FAILURE],
		uri: '/api/claim',
		config: {
			method: 'post',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(claim),
		},
		payload: { claim },
	});
}

export function sendClaimErrorEmail(body) {
	return api({
		types: [types.CLAIM__SENDERROREMAIL_REQUEST, types.CLAIM__SENDERROREMAIL_SUCCESS, types.CLAIM__SENDERROREMAIL_FAILURE],
		uri: '/api/claim/sendClaimErrorEmail',
		shouldCallAPI: () => true,
		config: {
			method: 'post',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(body),
		},
		payload: { body },
	});
}

export function sendClaimDebugEmail(policyNumber, memberName, errorMessage, claim, attachments) {
    const attachmentList = attachments.map(function(att) {
        return {
			name: att.name,
			path: att.path,
			size: att.size,
			lastModified: att.lastModified,
			lastModifiedDate: att.lastModifiedDate,
            type: att.type
        };
	});

	const body = {
		policyNumber: policyNumber,
		memberName: memberName,
		errorMessage: errorMessage,
		claimDetails: JSON.stringify(claim),
		attachmentDetails: JSON.stringify(attachmentList)
    }
	
    return api({
		types: [types.CLAIM__SENDDEBUGEMAIL_REQUEST, types.CLAIM__SENDDEBUGEMAIL_SUCCESS, types.CLAIM__SENDDEBUGEMAIL_FAILURE],
        uri: '/api/claim/sendClaimDebugEmail',
        shouldCallAPI: () => true,
        config: {
            method: 'post',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        },
        payload: { body },
    });
}
